
export const updateFormFlowInputs = (data) => {
    return {
        type: 'UPDATE_FORM_FLOW_INPUTS',
        data
    }
};


export const clearFormFlow = () => {
    return {
        type: 'CLEAR_FORM_FLOW'
    }
};

export const updateFormFlowComputed = (data) => {
    return {
        type: 'UPDATE_FORM_FLOW_COMPUTED',
        data
    }
}



export const setFormFlowCurrStep = (data) => {
    return {
        type: 'SET_FORM_FLOW_CURR_STEP',
        data
    }
}
